/**
 * PlaceSeasonIndicator – diskret lågmäld indikator: "Säsong just nu: Vinter"
 * Visas ENBART när overlay finns för aktuell säsong.
 */
import { Leaf } from 'lucide-react';
import type { Season } from '@/lib/season';
import { useTranslate } from '@/i18n';

interface Props {
  season: Season;
}

export function PlaceSeasonIndicator({ season }: Props) {
  const t = useTranslate();
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Leaf className="h-3 w-3" />
      <span>{t("place.season.indicator", { season: t(`season.${season}`) })}</span>
    </div>
  );
}
